import { Axios } from "../axios";
import { IMargin } from "./margin";

export const getMargin = async () => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  if (currentUser !== null && currentUser !== undefined) {
    return await Axios.get(`/remit/fxRates/${currentUser.vendor_key}/getMarginValue`, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: currentUser.idToken,
      },
    });
  }
};

export const getIBRRate = async (currentUser: IMargin.IGetIBrRateProps) => {
  if (currentUser !== null && currentUser !== undefined) {
    return await Axios.get(`/remit/fxRates/rate-card`, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: currentUser.idToken,
      },
    });
  }
};

export const updateMargin = async (marginValue: IMargin.IUpdateMarginProps) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

  if (currentUser !== null && currentUser !== undefined) {
    return await Axios.put(`/remit/fxRates/marginUpdate`, marginValue, {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    });
  }
};

export const updateFee = async (feeData: IMargin.IUpdateFeeProps) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

  if (currentUser !== null && currentUser !== undefined) {
    return await Axios.put(`/remit/fxRates/vendorSetting`, feeData, {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    });
  }
};

export const callRatesApi = async () => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

  if (currentUser !== null && currentUser !== undefined) {
    return await Axios.get(`/remit/fxRates/card-rate`, {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    });
  }
};
